import getSymbolFromCurrency from "currency-symbol-map";
import React from "react";
export default function Currency({ currency }) {
  return <span>{getSymbolFromCurrency(currency)}</span>;
}
